import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PermissionUiService {

  private deniedSections$ = new BehaviorSubject<Map<string, string>>(new Map());

  deny(sectionId: string, message?: string): void {
    const map = new Map(this.deniedSections$.value);
    map.set(
      sectionId,
      message ?? 'You do not have permission to view this section'
    );
    this.deniedSections$.next(map);
  }

  allow(sectionId: string): void {
    const map = new Map(this.deniedSections$.value);
    map.delete(sectionId);
    this.deniedSections$.next(map);
  }

  getDeniedMessage(sectionId: string): string | null {
    return this.deniedSections$.value.get(sectionId) ?? null;
  }

  watch(sectionId: string): Observable<string | null> {
    return this.deniedSections$.pipe(
      map(m => m.get(sectionId) ?? null),
      distinctUntilChanged()
    );
  }
}
